module.exports = __webpack_public_path__ + "img/border_heart.64205099.svg";